import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { ThrobberService } from 'src/app/_services/throbber.service';
import { environment } from 'src/environments/environment';
import { CriterioEvaluado } from '../retroalimentacion/models/criterio-evaluado';
import { Autoevaluacion } from './autoevaluacion';

const API_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class AutoevaluacionService {

  private cambiosEventoSubject = new BehaviorSubject<
  {alumnoId: number, criterioId: number, unidadEventoMateriaId: number,
    accion: string}>({alumnoId: null, criterioId: null, unidadEventoMateriaId: null, accion: null});
  cambiosEvento$ = this.cambiosEventoSubject.asObservable();

  private cambiosCompletadoSubject = new BehaviorSubject<{criterios: {unidadEventoMateriaId: number,
    criterioId: number, alumnoId: number}[], accion: string}>({criterios: [], accion: null});
  cambiosCompletado$ = this.cambiosCompletadoSubject.asObservable();

  constructor(
    private http: HttpClient,
    private customAlertService: CustomAlertService,
    private throbber: ThrobberService) { }

  getAutoevaluacionesAlumno(unidadID: string, alumnoID: string): Observable<Autoevaluacion[]> {
    return of([{
      id: 1,
      requiere: true,
      completo: false,
      unidadEventoMateriaId: 1,
      eventoId: 1,
      eventoMateriaAlumnoId: 1,
      alumnoId: 54,
      nombres: 'Agapito',
      nombresApellidos: 'Agapito Cervantes',
      apellidosNombres: 'Agapito Cervantes',
      apellidoP: 'Cervantes',
      apellidoS: 'Quevedo',
      eMail: 'asdasd@asd',
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Cervantes_J%C3%A1uregui.jpg/330px-Cervantes_J%C3%A1uregui.jpg',
      rol: [],
      apps: [],
      calendar: 'asd',
      curso: {},
      getNombre: () => 'sdf',
      codigo: 543,
    }]);
  }

  getAutoevaluacionAlumno(eventoMateriaId: number, alumnoId: number) {
    const response$ = this.http.get<any>(`${API_URL}/api/EventoAlumnoAutoevaluacion/evento/${eventoMateriaId}/alumno/${alumnoId}`);
    // const response$: Observable<Autoevaluacion> = of({
    //   id: 1,
    //   criteriosAutoevaluacion: [
    //     {unidadEventoMateriaId: 3, criterioId: 525741, alumnoId: 5}
    //   ],
    //   criterioNivel: [{
    //     criterioParentId: 1, nivel: 2
    //   }],
    //   alumnoId: 54,
    //   nombres: 'Agapito',
    //   nombresApellidos: 'Agapito Cervantes',
    //   apellidosNombres: 'Agapito Cervantes',
    //   apellidoP: 'Cervantes',
    //   apellidoS: 'Quevedo',
    //   eMail: 'asdasd@asd',
    //   imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Cervantes_J%C3%A1uregui.jpg/330px-Cervantes_J%C3%A1uregui.jpg',
    //   rol: [],
    //   apps: [],
    //   calendar: 'asd',
    //   curso: {},
    //   getNombre: () => 'sdf',
    //   codigo: 543,
    //   requiere: true,
    //   eventoId: 6,
    //   fecha: '02-03-2021',
    //   unidadEventoMateriaId: 7,
    //   eventoMateriaAlumnoConfig: {
    //     id: 1,
    //     eventoMateriaAlumnoId: 1,
    //     completoAutoevaluacion: false,
    //     requiereAutoevaluacion: true,
    //     requiereAutoevaluacionComentario: true,
    //     mostrarEvidenciaDetalle: false,
    //     mostrarColoresEscala: false
    //   }
    // });

    const cambiosDeAutoevaluacion$ = combineLatest([response$, this.cambiosEvento$]).pipe(
      map(([autoevaluacion, cambios]) => {
        if (cambios.accion === 'create') {
          const criterio = {
            alumnoId: cambios.alumnoId,
            criterioId: cambios.criterioId,
            unidadEventoMateriaId: cambios.unidadEventoMateriaId
          };
          autoevaluacion.criteriosAutoevaluacion.push(criterio);
        } else if (cambios.accion === 'delete') {
          autoevaluacion.criteriosAutoevaluacion
            = autoevaluacion.criteriosAutoevaluacion.filter(item => item.criterioId !== cambios.criterioId);
        }
        return autoevaluacion;
      })
    );

    return combineLatest([cambiosDeAutoevaluacion$, this.cambiosCompletado$]).pipe(
      map(([autoevaluacion, cambios]) => {
        if (cambios.accion === 'completa') {
          autoevaluacion.eventoMateriaAlumnoConfig.completoAutoevaluacion = true;
          autoevaluacion.criterios = cambios.criterios;
        }
        return autoevaluacion;
      }),
      catchError(err => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `Hubo un error al traer su evaluación, si este persiste por favor comunicarse con soporte. <br> Código de error: ${err.statusText}`
        });
        return of(true);
      })
    );
  }

  setEstadoEvaluacionCriterio(obj): Observable<any> {
      // return of(obj);
      return this.http.post(`${API_URL}/api/EventoAlumnoAutoevaluacion/criterio`, obj);
  }

  deleteEvaluacion(idCriterio, unidadEventoMateriaId, alumnoId) {
    return this.http.delete(`${API_URL}/api/EventoAlumnoAutoevaluacion/criterio/borrar/${idCriterio}/alumno/${alumnoId}/unidadeventomateria/${unidadEventoMateriaId}`);
  }

  setAutoevaluacionCompleta(autoevaluacionId: number, alumnoId, unidadEventoMateriaId): Observable<any> {
    this.throbber.setThrobberState(true);
    // TODO: URL
    return this.http.put<any>(`${API_URL}/api/EventoAlumnoAutoevaluacion/completo`, autoevaluacionId).pipe(
    // return of(false).pipe(
      catchError((err) => {
        this.throbber.setThrobberState(false);
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible guardar la evaluación. <br> Código de error: ${err.statusText}`
        });
        return of(true);
      }),
      mergeMap((data) => {
        if (data !== true) {
          return this.getDataEvaluacionAlumno(unidadEventoMateriaId, alumnoId);
        } else {
          return of(data);
        }
      })
    );
  }

  getDataEvaluacionAlumno(unidadEventoMateriaId, idAlumno) {
    return this.http.get<{unidadEventoMateriaId: number, criterioId: number, alumnoId: number}[]>(`${API_URL}/api/EventoAlumnoAutoevaluacion/criterios/evento/${unidadEventoMateriaId}/alumno/${idAlumno}`).pipe(
    // return of([{
    //   unidadEventoMateriaId: 0,
    //   alumnoId: 0,
    //   criterioId: 525741
    // }, {
    //   unidadEventoMateriaId: 0,
    //   alumnoId: 0,
    //   criterioId: 528222
    // }, {
    //   unidadEventoMateriaId: 0,
    //   alumnoId: 0,
    //   criterioId: 530251
    // }]).pipe(
      catchError((err) => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `Error al traer la retroalimentación del profesor. <br> Código de error: ${err.statusText}`
        });
        return of(true);
      }),
      map((data) => {
        this.throbber.setThrobberState(false);
        if ( typeof data === 'boolean') {
          return [];
        } else {
          this.cambiosCompletadoSubject.next({criterios: data, accion: 'completa'});
          return data;
        }
      })
    );
  }

  // Emiters de subjects de cambios.

  cambiosEmit(alumnoId: number, criterioId: number, unidadEventoMateriaId: number, accion: string) {
    this.cambiosEventoSubject.next(
      {alumnoId, criterioId, unidadEventoMateriaId , accion: accion});
  }

  cambiosEmitCompleto(criterios: {alumnoId: number, criterioId: number, unidadEventoMateriaId: number}[], accion: string) {
    this.cambiosCompletadoSubject.next(
      {criterios , accion: accion});
  }

}
